(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .directive('swifTaskSurveys', swifTaskSurveys);


    /**
        * @ngdoc directive
        * @name swif.patrimoine:swifTaskSurveys
        * @module swif.patrimoine
        * @restrict E
        * @usage
        <swif-task-surveys ng-model="model"></swif-task
    **/
    function swifTaskSurveys(swif) {
        'ngInject';
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope = {
            statesProperty: '=',
            allSurveysRequired: '=?'
        };
        d.link = function (scope, element, attr, ngModel) {
            swif.form.watchNgRequired(scope, element);
            swif.form.copyAttributesToInput(scope, element, attr);
            scope.form = scope.$parent.form;

            ngModel.$render = function () {
                var vv = ngModel.$viewValue;
                if (scope.allSurveysRequired) {
                    _.forEach(vv, function (item) {
                        item.done = true;
                    });
                }
                scope.proxy = vv;
            };

            scope.$watch('proxy', function (newV, oldV) {
                if(newV !== oldV) {
                    ngModel.$setViewValue(newV);
                }
            }, true);
        };
        d.templateUrl = 'partials/patrimoine/form_task_surveys_directive.html';
        return d;
    }


})();
